import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import axios from '../../../../library/axios';
import {
  handleJobQueuedSuccess,
  handleJobRequestError,
} from '../../../../helpers/cpanelJobFeedback';
import { USER_SCOPE_CENTRAL } from './constants';

const ExportCpanelUserComp = ({ scope, tenantSlug, close }) => {
  const isCentral = scope === USER_SCOPE_CENTRAL;
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('csv');

  const scopeHint = isCentral
    ? 'Mengekspor pengguna CPanel Center (tab aktif: Pengguna CPanel Center).'
    : tenantSlug
      ? `Mengekspor pengguna rumah sakit tenant "${tenantSlug}" (sesuai filter tabel).`
      : 'Mengekspor pengguna rumah sakit semua tenant (sesuai filter tabel: Semua tenant).';

  const handleExport = async (event) => {
    event?.preventDefault();
    setLoading(true);
    try {
      const params = { scope, type };
      if (!isCentral) params.tenantSlug = tenantSlug;
      const response = await axios.get('/cpanel/users/export', { params });
      await handleJobQueuedSuccess({
        response,
        actionLabel: isCentral ? 'Ekspor pengguna CPanel Center' : 'Ekspor pengguna rumah sakit',
        close,
      });
    } catch (err) {
      handleJobRequestError(err, 'Tidak dapat memulai ekspor pengguna.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleExport}>
      <p className="text-muted small mb-3">{scopeHint}</p>
      <div className="mb-4">
        <label className="form-label">Format file</label>
        <select className="form-select" value={type} onChange={(e) => setType(e.target.value)}>
          <option value="csv">CSV</option>
          <option value="xlsx">XLSX</option>
          <option value="xls">XLS</option>
        </select>
      </div>
      <div className="d-flex gap-2 justify-content-end">
        <Button variant="light" onClick={close} disabled={loading}>
          Batal
        </Button>
        <Button type="submit" variant="primary" disabled={loading}>
          {loading ? 'Memproses...' : 'Ekspor'}
        </Button>
      </div>
    </form>
  );
};

export default ExportCpanelUserComp;
